import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Inject,
  Input,
  OnInit
}                           from '@angular/core';
import {
  BlockUI,
  NgBlockUI
 }                          from 'ng-block-ui';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { FlipperSidesModel }             from '../shared/components/flipper/typings/flipper.sides';
import { HaynesProService }              from './haynes-pro.service';
import { HaynesProVehicleInfoModel }     from './typings/haynes-pro.vehicle-info';
import { HaynesProVehicleMakeModel }     from './typings/haynes-pro.vehicle-make';
import { HaynesProVehicleModelModel }    from './typings/haynes-pro.vehicle-model';
import { HaynesProVehicleSubnodesModel } from './typings/haynes-pro.vehicle-sub-nodes';
import { HaynesProVehicleTypeModel }     from './typings/haynes-pro.vehicle-type';
import { MessagesService }               from '../messages/messages.service';
import { Table }                         from '../table/types/table';
import { VehicleModel }                  from '../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-vehicle-selection',
  template: require('./haynes-pro.vehicle-selection.component.html')
})
export class HaynesProVehicleSelectionComponent implements OnInit {
  @BlockUI('haynesProVehicleSelectionBackBlock')  backBlock  : NgBlockUI;
  @BlockUI('haynesProVehicleSelectionFrontBlock') frontBlock : NgBlockUI;

  @Input() activeSide : FlipperSidesModel = 'front';
  @Input() vehicle    : VehicleModel;
  @Input() vehicles   : Array<HaynesProVehicleInfoModel>;

  selectedVehicle ?: HaynesProVehicleInfoModel;

  filteredMakes : Array<HaynesProVehicleMakeModel>     = [];
  filteredModels: Array<HaynesProVehicleSubnodesModel> = [];
  selectedModel : HaynesProVehicleModelModel           = {} as HaynesProVehicleModelModel;
  truckTypes    : Array<HaynesProVehicleTypeModel>     = this.haynesProService.getTruckTypes();
  vehicleMakes  : Array<HaynesProVehicleMakeModel>     = [];
  vehicleModels : Array<HaynesProVehicleSubnodesModel> = [];
  vehicleTypes  : Array<HaynesProVehicleTypeModel>     = this.haynesProService.getVehicleTypes();

  truckTypeActiveTab   = '*';
  vehicleTypeActiveTab = '*';

  filters = {
    make : '',
    model: ''
  };

  tableSettings : Table = {
    columns: [
      {
        field : 'full_name',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.FULL_NAME')
        }
      },
      {
        field : 'engine_code',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.ENGINE_CODE')
        }
      },
      {
        field : 'fuel_type',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.FUEL_TYPE')
        },
      },
      {
        field : 'power',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.POWER')
        }
      },
      {
        field : 'capacity',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.CAPACITY')
        }
      },
      {
        field : 'model_years',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.MADE_YEARS')
        }
      },
      {
        field : 'variant_code',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.VARIANT_CODE')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_RECORDS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  constructor (
    public  activeModal      : NgbActiveModal,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(forwardRef(() => HaynesProService))
    public  haynesProService : HaynesProService,
    private messagesService  : MessagesService,
    private translateService : TranslateService
  ) {}

  ngOnInit () : void {
    this.filterMakes();
    this.filterModels();

    this.vehicleTypeActiveTab = this.vehicleTypes[ 0 ].name;

    this.onTabSelect(this.vehicleTypeActiveTab, 'vehicle');
  }

  changeSide ( side : FlipperSidesModel = 'back' ) : void {
    this.activeSide = side;

    if ( side === 'front' && this.vehicles.length === 1 ) {
      this.confirmSelection(this.vehicles[ 0 ]);
    }

    this.changeDetectorRef.detectChanges();
  }

  confirmSelection ( vehicle : HaynesProVehicleInfoModel = this.selectedVehicle ) : void {
    this.vehicle.haynes_pro_vehicle_id = vehicle.id;

    this.activeModal.close(this.vehicle);
  }

  filterMakes () : void {
    this.filteredMakes = this.filters.make === ''
      ? this.vehicleMakes
      : this.vehicleMakes.filter(make => make.full_name.toLowerCase()
        .includes(this.filters.make.toLowerCase()));

    this.filteredMakes.forEach(make => make.selected = false);

    this.vehicleModels = [];
    this.selectedModel = {} as HaynesProVehicleModelModel;

    this.filters.model = '';
    this.filterModels();
  }

  filterModels () : void {
    this.filteredModels = this.filters.model === ''
      ? this.vehicleModels
      : this.vehicleModels.filter(model => model.full_name.toLowerCase()
        .includes(this.filters.model.toLowerCase()));
  }

  onMakeSelect ( make : HaynesProVehicleMakeModel ) : void {
    this.backBlock.start();

    this.vehicleModels = [];
    this.selectedModel = {} as HaynesProVehicleModelModel;

    this.filterModels();

    this.haynesProService.getVehicleModels(this.vehicle, this.vehicleTypeActiveTab, this.truckTypeActiveTab, make)
    .then(( models : Array<HaynesProVehicleSubnodesModel> ) => {
      this.vehicleModels = models;

      this.filters.model = '';

      this.filterModels();
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.backBlock.stop());
  }

  onModelSelect ( model : HaynesProVehicleModelModel ) : void {
    this.backBlock.start();

    this.selectedModel = {} as HaynesProVehicleModelModel;

    this.haynesProService.getVehicleVariantsBySearch(this.vehicle, model)
    .then(( vehicleDetails : HaynesProVehicleModelModel ) => {
      this.selectedModel   = vehicleDetails;
      this.vehicles.length = 0;

      this.vehicles.push(...vehicleDetails.sub_nodes);
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.backBlock.stop());
  }

  onSelect ( vehicle : HaynesProVehicleInfoModel ) : void {
    this.selectedVehicle = vehicle.selected
      ? vehicle
      : null;
  }

  onTabSelect ( value : string, type : string ) : void {
    this.selectedModel = {} as HaynesProVehicleModelModel;
    this.vehicleMakes  = [];
    this.vehicleModels = [];

    this.filterMakes();
    this.filterModels();

    if ( type === 'vehicle' && value === 'trucks' ) {
      return;
    }

    this.backBlock.start();

    const isVehicle   = type === 'vehicle' && value !== 'trucks';
    const vehicleType = isVehicle
      ? value
      : 'trucks';

    this.truckTypeActiveTab = isVehicle
      ? '*'
      : value;

    this.haynesProService.getVehicleMakes(this.vehicle, vehicleType, this.truckTypeActiveTab)
    .then(makes => {
      this.vehicleMakes = makes;

      this.filters.make = '';

      this.filterMakes();
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.backBlock.stop());
  }
}
